import { bootstrapApplication } from '@angular/platform-browser';

import packageJson from '../package.json';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

console.info(`SafeHire v${packageJson.version}`);

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
